package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.DownloadW500Rounded: ImageVector
    get() {
        if (_downloadW500Rounded != null) {
            return _downloadW500Rounded!!
        }
        _downloadW500Rounded = Builder(name = "DownloadW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(462.85f, 614.88f)
                quadToRelative(-8.2f, -3.1f, -14.92f, -9.81f)
                lineTo(300.35f, 457.48f)
                quadToRelative(-13.44f, -13.44f, -13.06f, -31.83f)
                quadToRelative(0.38f, -18.39f, 13.06f, -31.82f)
                quadToRelative(13.67f, -13.68f, 32.32f, -14.06f)
                quadToRelative(18.66f, -0.38f, 32.33f, 13.29f)
                lineToRelative(69.5f, 69.5f)
                verticalLineToRelative(-265.19f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                verticalLineToRelative(265.19f)
                lineToRelative(69.5f, -69.5f)
                quadToRelative(13.43f, -13.67f, 32.09f, -13.41f)
                quadToRelative(18.65f, 0.26f, 32.32f, 13.94f)
                quadToRelative(12.92f, 13.67f, 13.3f, 31.94f)
                quadToRelative(0.38f, 18.27f, -13.3f, 31.95f)
                lineTo(512.07f, 605.07f)
                quadToRelative(-6.72f, 6.71f, -14.92f, 9.81f)
                quadToRelative(-8.19f, 3.1f, -17.15f, 3.1f)
                quadToRelative(-8.96f, 0.0f, -17.15f, -3.1f)
                close()
                moveTo(242.87f, 808.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-74.5f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                verticalLineToRelative(74.5f)
                horizontalLineToRelative(474.26f)
                verticalLineToRelative(-74.5f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                verticalLineToRelative(74.5f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(242.87f, 808.13f)
                close()
            }
        }
        .build()
        return _downloadW500Rounded!!
    }

private var _downloadW500Rounded: ImageVector? = null
